import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { baseHttpRequestOptions } from '@app/core/services/services.utils';
import { User } from '@app/core/models/user/user.model';
import { Observable, Subject, BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private _userProfile: Subject<User> = new BehaviorSubject<User>(null);

  public readonly userProfile: Observable<User> = this._userProfile.asObservable();

  constructor(private readonly httpClient: HttpClient) {}

  loadUserProfile() {
    return this.httpClient
      .get(`${environment.apiURL}/user`, baseHttpRequestOptions)
      .subscribe((response: any) => {
        this._userProfile.next(this.transformUserResponseToUserObject(response.data));
      });
  }

  sharedProtocol;
  updateUserProfile(newUserProfile: User): Observable<any> {
    return this.httpClient
      .put(
        `${environment.apiURL}/user`,
        {
          cpf: newUserProfile.CPF,
          email: newUserProfile.email,
          name: newUserProfile.fullName,
          birthDate: newUserProfile.birthDate, // TODO :: ISSUES IN BACK-END
          sex: newUserProfile.gender,
          motherName: newUserProfile.motherName,
          fatherName: newUserProfile.fatherName,
          nationality: newUserProfile.nationality,
          citizenship: newUserProfile.citizenship,
          hometown: newUserProfile.address.hometown,
          maritalStatus: newUserProfile.maritalStatus,
          neighborhood: newUserProfile.address.neighborhood,
          street: newUserProfile.address.street,
          addressNumber: newUserProfile.address.number,
          complement: newUserProfile.address.complement,
          cep: newUserProfile.address.cep,
          city: newUserProfile.address.city,
          state: newUserProfile.address.state,
          proofOfResidence: newUserProfile.address.attachment,
          telephone: newUserProfile.contact.telephone,
          cellphone: newUserProfile.contact.cellphone,
          favoriteContact: newUserProfile.contact.preferentialCommunicationChannel,
          password: newUserProfile.password,
          passwordRepeat: newUserProfile.passwordRepeat,
          interests: newUserProfile.interests,
        },
        baseHttpRequestOptions
      )
      .pipe(
        map((data: any) => {
          this.sharedProtocol = data?.data?.update?.protocolo;
          return data;
        })
      );
  }

  private transformUserResponseToUserObject(userResponse): User {
    return {
      password: userResponse.password,
      passwordRepeat: userResponse.passwordRepeat,
      CPF: userResponse.cpf,
      email: userResponse.email,
      fullName: userResponse.name,
      birthDate: userResponse.birthDate,
      gender: userResponse.sex === 'Feminino' ? 'FEMALE' : 'MALE',
      motherName: userResponse.motherName,
      fatherName: userResponse.fatherName,
      maritalStatus: userResponse.maritalStatus,
      citizenship: userResponse.citizenship,
      nationality: userResponse.nationality,

      address: {
        hometown: userResponse.hometown,
        neighborhood: userResponse.neighborhood,
        street: userResponse.street,
        number: userResponse.addressNumber,
        complement: userResponse.complement,
        cep: userResponse.cep,
        city: userResponse.city,
        state: userResponse.state,
      },

      contact: {
        telephone: userResponse.telephone,
        cellphone: userResponse.cellphone,
        preferentialCommunicationChannel: userResponse.favoriteContact,
      },
      interests: userResponse.interests,
    };
  }
}
